export default __webpack_public_path__ + "static/media/home_yiwang__navigation.ccf86863.png";